export default __webpack_public_path__ + "static/media/wh_6.cdd5b459.mp3";